import React, { useEffect, useRef } from 'react';
import './HtmlContentRenderer.css';

export const HtmlContentRenderer = ({ htmlContent, textStyles = {}, disabledImages = false, photo_url = '' }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            // Парсинг строки HTML
            const parser = new DOMParser();
            const parsedDoc = parser.parseFromString(htmlContent, 'text/html');

            // Если изображения нужно отключить, удаляем все <img> теги
            if (disabledImages) {
                parsedDoc.querySelectorAll('img').forEach(img => img.remove());
            } else {
                // Обрабатываем изображения
                parsedDoc.querySelectorAll('img').forEach(img => {
                    // Если передан photo_url, то заменяем src
                    if (photo_url) {
                        img.setAttribute('src', photo_url);
                    }

                    // Обновляем ширину, если задан атрибут width
                    const width = img.getAttribute('width');
                    if (width) {
                        img.setAttribute('width', width);
                    }
                });
            }

            // Добавляем класс к blockquote, так как стили применялись в Quill редакторе
            parsedDoc.querySelectorAll('blockquote').forEach(blockquote => {
                blockquote.classList.add('custom-blockquote');
            });

            // Обновляем содержимое контейнера
            container.innerHTML = parsedDoc.body.innerHTML;
        }
    }, [htmlContent, disabledImages, photo_url]);

    return <div ref={containerRef} style={textStyles} />;
};
